(() => {
    const GLOBAL_INIT_KEY = '__s1_4wd_video_grid_registered__';
    if (window[GLOBAL_INIT_KEY]) return;
    window[GLOBAL_INIT_KEY] = true;

    const MB_MAX_WIDTH = '(max-width: 1000px)';

    class S14wdVideoGridSection extends HTMLElement {
        connectedCallback() {
            this.initClickToLoad();
            this.initMobileScroll();
        }

        disconnectedCallback() {
            if (this.mbScrollContainer && this.onMbScroll) {
                this.mbScrollContainer.removeEventListener('scroll', this.onMbScroll);
            }
            if (this.onMbResize) {
                window.removeEventListener('resize', this.onMbResize);
            }
            if (this.mbPrevButton && this.onMbPrevClick) {
                this.mbPrevButton.removeEventListener('click', this.onMbPrevClick);
            }
            if (this.mbNextButton && this.onMbNextClick) {
                this.mbNextButton.removeEventListener('click', this.onMbNextClick);
            }
        }

        initClickToLoad() {
            this.querySelectorAll('[data-s1-4wd-video-grid-item]').forEach((item) => {
                const trigger = item.querySelector('[data-s1-4wd-video-grid-trigger]');
                if (!trigger || trigger.disabled) return;

                trigger.addEventListener('click', () => this.loadVideo(item), { once: true });
            });
        }

        initMobileScroll() {
            this.mbScrollContainer = this.querySelector('.s1-4wd-video-grid-container-mb');
            this.mbPrevButton = this.querySelector('.s1-4wd-video-grid-container-mb-button-prev');
            this.mbNextButton = this.querySelector('.s1-4wd-video-grid-container-mb-button-next');

            if (!this.mbScrollContainer || !this.mbPrevButton || !this.mbNextButton) return;

            this.onMbScroll = () => this.updateMbScrollButtons();
            this.onMbResize = () => this.updateMbScrollButtons();
            this.onMbPrevClick = () => this.scrollMb(-1);
            this.onMbNextClick = () => this.scrollMb(1);

            this.mbScrollContainer.addEventListener('scroll', this.onMbScroll, { passive: true });
            this.mbPrevButton.addEventListener('click', this.onMbPrevClick);
            this.mbNextButton.addEventListener('click', this.onMbNextClick);
            window.addEventListener('resize', this.onMbResize);

            this.updateMbScrollButtons();
        }

        getMbScrollStep() {
            const container = this.mbScrollContainer;
            if (!container) return 0;

            const grid = container.querySelector('.s1-4wd-video-grid--mb');
            const firstItem = grid?.querySelector('.s1-4wd-video-grid-item');

            if (firstItem) {
                const gap = grid ? parseFloat(getComputedStyle(grid).columnGap || getComputedStyle(grid).gap) || 0 : 0;
                return firstItem.offsetWidth + gap;
            }

            return container.clientWidth;
        }

        scrollMb(direction) {
            const container = this.mbScrollContainer;
            if (!container || !window.matchMedia(MB_MAX_WIDTH).matches) return;

            const step = this.getMbScrollStep();
            if (!step) return;

            container.scrollBy({ left: direction * step, behavior: 'smooth' });
        }

        updateMbScrollButtons() {
            const container = this.mbScrollContainer;
            if (!container || !this.mbPrevButton || !this.mbNextButton) return;

            const isMobile = window.matchMedia(MB_MAX_WIDTH).matches;
            const maxScroll = Math.max(0, container.scrollWidth - container.clientWidth);
            const canScroll = isMobile && maxScroll > 1;
            const atStart = container.scrollLeft <= 1;
            const atEnd = container.scrollLeft >= maxScroll - 1;

            this.mbPrevButton.disabled = !canScroll || atStart;
            this.mbNextButton.disabled = !canScroll || atEnd;
            this.mbPrevButton.setAttribute('aria-disabled', String(this.mbPrevButton.disabled));
            this.mbNextButton.setAttribute('aria-disabled', String(this.mbNextButton.disabled));
        }

        loadVideo(item) {
            if (item.dataset.videoLoaded === 'true') return;

            const provider = item.dataset.videoProvider;
            const embedId = item.dataset.videoEmbedId;
            if (!provider || !embedId) return;

            const poster = item.querySelector('.s1-4wd-video-grid-item__poster');
            const playerHost = item.querySelector('.s1-4wd-video-grid-item__player');
            if (!playerHost) return;

            const plyrNode = document.createElement('div');
            plyrNode.className = 's1-4wd-video-grid-plyr';
            plyrNode.setAttribute('data-plyr-provider', provider);
            plyrNode.setAttribute('data-plyr-embed-id', embedId);
            playerHost.appendChild(plyrNode);

            item.dataset.videoLoaded = 'true';
            item.classList.add('is-playing');
            if (poster) poster.setAttribute('hidden', '');

            this.initPlyrPlayer(plyrNode);
        }

        initPlyrPlayer(node) {
            let attempts = 0;
            const maxAttempts = 20;
            const intervalMs = 200;

            const timer = window.setInterval(() => {
                attempts += 1;
                if (this.createPlyr(node) || attempts >= maxAttempts) {
                    window.clearInterval(timer);
                }
            }, intervalMs);
        }

        createPlyr(node) {
            if (!window.Plyr || node.dataset.plyrInited === 'true') return !!window.Plyr;

            const player = new Plyr(node, {
                controls: ['play-large', 'play', 'progress', 'fullscreen'],
                youtube: {
                    rel: 0,
                    showinfo: 0,
                    iv_load_policy: 3,
                    mute: 1,
                },
                vimeo: {
                    byline: false,
                    portrait: false,
                    title: false,
                },
            });

            player.on('ready', () => {
                player.play();
            });

            node.dataset.plyrInited = 'true';
            return true;
        }
    }

    if (!customElements.get('s1-4wd-video-grid-section')) {
        customElements.define('s1-4wd-video-grid-section', S14wdVideoGridSection);
    }
})();
